// var secondSelect = [];
// var filterSecondSelect = [];

// function fetchObject() {
// 	var request;
// 	if (window.XMLHttpRequest) {
// 		request = new XMLHttpRequest();
// 	}
// 	let fileName = valuesInDependence;
// 	request.open('GET', fileName);
// 	request.onreadystatechange = function () {
// 		if ((request.readyState === 4) && (request.status === 200)) {
// 			var res = JSON.parse(request.responseText);
// 			secondSelect = res;

// 		}
// 	};
// 	request.send();
// }

// $("select.parentSelect").on('change', function () {
// 	var selectValue = $(this).val();
// 	specialSecondSelect(selectValue);
// 	$(".childSelect option").remove();
// 	$('select.childSelect').append(filterSecondSelect.map(el => {
// 		return `<option value="${el.value}">${el.label}</option>`
// 	}));
// 	$('.selectpicker').selectpicker("refresh");
// });

// function specialSecondSelect(selectValue) {
// 	filterSecondSelect = secondSelect[selectValue];
// }

// fetchObject();





//start old





//end old
var filterSecondSelect = [];
var valuesInDependenceVar;
$("select.parentSelect").on('change', function () {
	var selectValue = $(this).val();
	let childSelect=$(this).closest('.selectsWrapp').find('select.childSelect')
	let valuesInDependenceVar=eval($(this).data('toapply'));
	specialSecondSelect(selectValue ,valuesInDependenceVar);
	childSelect.find("option").remove();
	childSelect.append(filterSecondSelect && filterSecondSelect.map(el => {
		return `<option value="${el.value}">${el.label}</option>`
	}));
	childSelect.removeClass('disabledSelect');
	$(this).closest('.selectsWrapp').find('.dropdown.bootstrap-select').removeClass('disabledSelect');
	$('.selectpicker').selectpicker("refresh");
});

function specialSecondSelect(selectValue ,valuesInDependence) {
	filterSecondSelect = valuesInDependence[selectValue]
}
